import React from 'react';

import Base from './Base.jsx';

import AssetResearch from '../Components/AssetResearch/index.jsx';
import PagedData from '../Components/PagedData/index.jsx';

import TaggedContent from '../Services/TaggedContent/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-asset-research';
  }

  renderElement(element) {
    var term = element.dataset.term;

    var api = new TaggedContent(term, false);

    var WrappedComponent = PagedData(AssetResearch.List, api);

    return (
      <AssetResearch>
        <WrappedComponent />
      </AssetResearch>
    );
  }
}


export default EntryPoint;

